import { Language } from "@app/core/user/domain/language";
import { Unit } from "./unit";

export interface UserConfigurationParams {
  language: Language | null;
  availableLanguages?: Language[];
  units: Unit | null;
  availableUnits?: Unit[];
  hasChat?: boolean;
}

export class UserConfiguration {
  readonly language: Language | null;
  readonly availableLanguages?: Language[];
  readonly units: Unit | null;
  readonly availableUnits?: Unit[];
  readonly hasChat: boolean;

  constructor(params: UserConfigurationParams) {
    this.language = params.language;
    this.availableLanguages = params.availableLanguages;
    this.units = params.units;
    this.availableUnits = params.availableUnits;
    this.hasChat = params.hasChat ?? false;
  }
}
